import React from 'react';
import './DresscodePalette.css';

/**
 * DresscodePalette — a row of colour swatches with optional labels,
 * plus an optional gallery of reference photos.
 *
 * Props:
 *   swatches   — [{ color, label? }] or ['#fff', '#000'] style
 *   photos     — [{ url, filter? }] gallery (optional)
 *   cssFilter  — (photoMeta) => CSS filter string or undefined
 *   lightCols  — list of colour strings treated as "light" and given a
 *                subtle border. Default covers white-ish values.
 *   classes    — class map: wrap, swatchWrap, swatch, swatchLabel,
 *                photos, photo
 */
const DEFAULT_LIGHT = new Set(['#ffffff', '#fff', '#fffbf2']);

export default function DresscodePalette({
  swatches,
  photos,
  cssFilter,
  lightCols = DEFAULT_LIGHT,
  classes = {},
}) {
  /* Normalise to arrays — accept undefined / null / non-array gracefully so
     callers don't have to write `swatches={p.dresscode_palette || []}`
     every time. Empty arrays render nothing (the conditional blocks
     below short-circuit), so passing nothing == hidden block. */
  const _swatches = Array.isArray(swatches) ? swatches : [];
  const _photos   = Array.isArray(photos)   ? photos   : [];
  const cls = {
    wrap:        classes.wrap        || 'dc-swatches',
    swatchWrap:  classes.swatchWrap  || 'dc-swatch-wrap',
    swatch:      classes.swatch      || 'dc-swatch',
    swatchLabel: classes.swatchLabel || 'dc-swatch-label',
    photos:      classes.photos      || 'dc-photos',
    photo:       classes.photo       || 'dc-photo',
  };
  const src = u => !u ? null : (u.startsWith('http') ? u : u);
  return (
    <>
      {_swatches.length > 0 && (
        <div className={cls.wrap}>
          {_swatches.map((sw, i) => {
            const col = sw?.color || sw;
            const isLight = typeof col === 'string'
              && (lightCols.has(col) || lightCols.has(col.toLowerCase?.()));
            return (
              <div key={i} className={cls.swatchWrap}>
                <div className={cls.swatch}
                     style={{ background: col, border: isLight ? '1px solid rgba(0,0,0,0.15)' : 'none' }} />
                {/* Вывод названий цветов отключён по запросу.
                {sw?.label && <span className={cls.swatchLabel}>{sw.label}</span>}
                */}
              </div>
            );
          })}
        </div>
      )}
      {_photos.length > 0 && (
        <div className={cls.photos} data-dc-photos>
          {_photos.map((ph, i) => {
            const imgStyle = {};
            if (cssFilter) imgStyle.filter = cssFilter(ph);
            /* Respect the focal point chosen in the chatbot crop step so
               object-fit: cover keeps the face in frame. */
            if (Number.isFinite(ph?.focalX) && Number.isFinite(ph?.focalY)) {
              imgStyle.objectPosition = `${(ph.focalX * 100).toFixed(1)}% ${(ph.focalY * 100).toFixed(1)}%`;
            }
            return (
              <div key={i} className={cls.photo} data-dc-photo>
                <img src={src(ph.url)} alt="" style={Object.keys(imgStyle).length ? imgStyle : undefined} />
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
